import {SetGetListPaymentSystem} from './thunk/setGetListPaymentSystem';
import {SetPostCreatePaymentSystem} from './thunk/setPostCreatePaymentSystem';
import {SetUpdatePaymentSystem} from './thunk/setUpdatePaymentSystem';

export const Thunks = {
    SetGetListPaymentSystem,
    SetPostCreatePaymentSystem,
    SetUpdatePaymentSystem

}